import { Button, Center, Checkbox, Text } from '@chakra-ui/react';
import { Dialog } from '@halo/ui-react';
import type { User } from '@halo/chat-sdk-react';
import { Avatar } from '@halo/ui-chat-react';

export interface ContactDeleteDialogProps {
  loading: boolean;
  open: boolean;
  user: User | null;
  onOK: () => void;
  onClose: (open?: boolean) => void;
}

const ContactDeleteDialog = ({
  loading,
  open,
  user,
  onOK,
  onClose,
}: ContactDeleteDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog.Root
      placement="center"
      open={open}
      onOpenChange={({ open }) => onClose(open)}
      closeOnInteractOutside={false}
      unmountOnExit
    >
      <Dialog.Backdrop />
      <Dialog.Positioner zIndex={1501}>
        <Dialog.Content borderRadius="xl" w="428px" maxW="100%" bg="bg.subtle">
          <Dialog.Header p="5" fontSize="md" fontWeight="semibold" justifyContent="space-between">
            <Center gapX="2">
              <Avatar src={user?.avatar} size="lg" activeShake={false} />
              <Text>{t('tips.confirmDeletionOfThisContact')}</Text>
            </Center>
          </Dialog.Header>
          <Dialog.Body px="5" pt="1" pb="3" textAlign="center">
            <Checkbox.Root checked disabled>
              <Checkbox.HiddenInput />
              <Checkbox.Control />
              <Checkbox.Label>{t('tips.deleteBackupsSynchronously')}</Checkbox.Label>
            </Checkbox.Root>
          </Dialog.Body>
          <Dialog.Footer p="5">
            <Button
              h="10"
              borderRadius="xl"
              variant="ghost"
              color="fg"
              bg="bg.muted"
              onClick={() => onClose(false)}
            >
              {t('buttons.cancel')}
            </Button>
            <Button
              minW="96px"
              h="10"
              borderRadius="xl"
              bg="fg.error"
              loading={loading}
              onClick={onOK}
            >
              {t('buttons.deleteContact')}
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

const MemoizedContactDeleteDialog = memo(ContactDeleteDialog);

export { MemoizedContactDeleteDialog as ContactDeleteDialog };
